/** Figma design copy – single source of truth */

export const BASE = process.env.PUBLIC_URL || "";

export const HERO = {
  tagline: "Decoding New Trends for Age-Old Traditions",
};

export const ABOUT = {
  title: "About Weddmac",
  main:
    "Specializing in contemporary photography and filmmaking, weddmac  has been capturing the love and wedding stories of couples with unparalleled artistry. Our dedication lies in capturing your love story with elegance and precision.Each moment from your once in a lifetime event is meticulously selected and transformed into films and photographs you will treasure forever. weddmac, where every frame tells a story, and every story is a cherished memory.Weddmac emerged from a profound passion for photography and an exceptional aptitude for managing clients and orchestrating grand events. Our journey commenced in 2013, and since then, we have adeptly captured the essence of numerous weddings and pre-wedding celebrations.",
  quote:
    "Because your wedding deserves more than just photos. We blend traditional storytelling with new trends, decoding what makes each celebration unique.",
  sub: "Capturing the madness and chaos we call weddings — with artistry, care, and an eye for the moments that matter.",
};

export const QUOTE = "Because your wedding deserves more than just photos.";

export const SECTION = "Capturing the Madness and Chaos we call Weddings";

export const CONTACT = {
  heading: "CONTACT US",
  mobile: "mobile :- 9096846462",
  email: "email :- weddmacphotography@gmail.com",
  copyright: "COPYRIGHT 2026 ALL RIGHTS RESERVED",
};

export const GET_IN_TOUCH = {
  title: "Get In Touch",
  intro:
    "Let's create something beautiful together. Reach out for bookings, inquiries, or collaborations.",
};

export const COUPLES = [
  "Ashwini & Shrikant",
  "Nikita & Partik",
  "Shivangi & Bhaumik",
];

export const NAV = [
  "Photography",
  "Gallery",
  "Films",
  "Blogs",
  "About",
  "Get In Touch",
];

/** Helper: prepend PUBLIC_URL for image src */
export function img(path) {
  return `${BASE}${path.startsWith("/") ? path : "/" + path}`;
}
